import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./rigidFlexPcb.png"

const リジッドフレキ基板 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { rigidFlexPcb: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="リジッドフレキ基板" src={img} helpURL={HELP_LINKS["リジッドフレキ基板"]}>
      <RadioGroup name={estimateField.rigidFlexPcb.key} selectedValue={values.rigidFlexPcb} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["リジッドフレキ基板"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["リジッドフレキ基板"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.rigidFlexPcb} />
    </OneClickField>
  )
}

export default リジッドフレキ基板
